import * as React from "react";
import { ProductReimbursableLogo } from "@grandvisionhq/lib-visuals";
import { useProductDetailQueryParams } from "../../../../../../../../hooks/hooks/use-product-detail-query-params.js";
import { useProductData } from "../../../../../../../../context/context/product-context-hooks.js";
import { useCmsData } from "../../../../../../../../context/context/CmsContext.js";
const ProductReimbursableLogoContainer = ({ className }) => {
  const { activeVariant } = useProductData();
  const { isReimbursable } = useProductDetailQueryParams();
  const { reimbursableLogos } = useCmsData();
  if (!activeVariant.isInsuranceReimbursable) return null;
  return /* @__PURE__ */ React.createElement(
    ProductReimbursableLogo,
    {
      defaultLogo: reimbursableLogos?.default,
      alternativeLogo: reimbursableLogos?.alternative,
      variant: isReimbursable ? "alternative" : "default",
      className
    }
  );
};
export {
  ProductReimbursableLogoContainer
};
//# sourceMappingURL=ProductReimbursableLogoContainer.js.map
